// pathRegexList.js
'use strict';

export const landingRegExp =
  /^\/(?!settings|404|tos|privacy|error|signup|login|addvalue|join|revenue|standalone|iframe|geo-blocked|apple-migration-rebind|anti-slavery|complaint-policy)/i;
export const ageVerifierRegExp =
  /^\/(?!settings|404|tos|privacy|error|login|join|revenue|standalone|iframe|geo-blocked|apple-migration-rebind)/i;
export const addvalueRegExp = /^\/(?!signup|login|404|geo-blocked)/i;

export const notAgeVerifyRegExp = /^\/(?!age-verify)/i;
